import {connect} from 'react-redux';
import Step12 from './Step12';
import {submitStep} from '../../actions/submitStep';
import {showGlobalErrorMessage} from '../../actions/globalErrorMessage/showGlobalErrorMessage';
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           stepPayload: {payload},
                           locales: {current: language},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  payload,
  language,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, showGlobalErrorMessage, prevCompletedStepSignFalse}
)(Step12);
